import { extend, override } from "flarum/extend";
import User from "flarum/common/models/User";
import ItemList from "flarum/utils/ItemList";
import GroupBadge from "flarum/forum/components/GroupBadge";
import Extend from "flarum/common/extenders";
import Group from "flarum/common/models/Group";
import Badge from "flarum/components/Badge";

const extended = [new Extend.Model(Group).attribute("priority")];

export { extended as extend };

app.initializers.add("lltq-group-badges", (app) => {
  override(User.prototype, "badges", function (original) {
    /**
     * Get the Badge components that apply to this user.
     * override to sort by priority
     */
    const items = new ItemList();
    const groups = this.groups();

    if (groups) {
      groups
        .sort((a, b) => a.priority() - b.priority())
        .forEach((group) => {
          items.add(`group${group?.id()}`, <GroupBadge group={group} />);
        });
    }

    /*
     * Add suspension badge if needed
     */
    const until = this.suspendedUntil();

    if (new Date() < until) {
      items.add(
        "suspended",
        <Badge
          icon="fas fa-ban"
          type="suspended"
          label={app.translator.trans(
            "flarum-suspend.forum.user_badge.suspended_tooltip"
          )}
        />
      );
    }

    return items;
  });
});
